import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './home/home.component';
import { dashboardRoutes } from './dashboard.routes';
import { AuthGuard } from '../guards/auth-guard.service';
import { RoleGuard } from '../guards/role-guard.service';
import { FormsModule ,ReactiveFormsModule }   from '@angular/forms';
import {DashboardChartComponent} from './dashboard_charts/DashboardCharts.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {SectionComponent} from '../sections/section.component';
import {SearchPanelComponent} from '../panel/searchPanel.component';
import {BoxComponent} from '../../app/boxes/boxes.component'; 
import {EventCalenderComponent} from './event_calender/event_calender.component'; 
import { ToastrModule } from 'ngx-toastr';
import {SearchPipe,FilterBySettings,FilterByReviewer,FilterByUser,highlight} from '../pipes/search';

import {ListItemComponent} from '../list_item/list_item.component'; 
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from './base/base.component';
import {SharedModule} from '../shared/shared.module';
import {MonthViewCompnent} from '../dashboard/month_view_cal/month_view_cal.component';
import {NgbdModalContent} from '../dashboard/modals/calender_create_newsletter/modal1.component';
import {NgbdModalBasic} from '../dashboard/modals/calender_invite_modal/invite_modal.component';
import {EditorZoom} from '../dashboard/modals/editorzoom/editorzoom';

import { ArticleComponent } from './article/article.component';
import { CreateArticleComponent } from './create-article/create-article.component';
import { HttpClientModule} from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { EditorModule } from '@tinymce/tinymce-angular';
import { ViewArticleComponent } from './view-article/view-article.component';
import { NewsletterListComponent } from './newsletter-list/newsletter-list.component';
import { NewsletterViewComponent } from './newsletter-view/newsletter-view.component';

import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {PrivacyComponent} from './privacy/privacy.component';
import { TemplateComponent } from './template/template.component';
import { SettingsComponent } from './settings/settings.component';
import { ManageArticleCategoryComponent } from './manage-article-category/manage-article-category.component';
import { ManageArticleTypeComponent } from './manage-article-type/manage-article-type.component';
import { ManageTemplateGroupComponent } from './manage-template-group/manage-template-group.component';

import { TemplaterComponent } from './templater/templater.component';
import { SearchComponent } from './search/search.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { TemplateListComponent } from './template-list/template-list.component';
import {UserSetPermissionComponent} from './user-set-permission/user-set-permission.component';
import { CommentreplyComponent } from './commentreply/commentreply.component';

import { NotificationListComponent } from './notification/notification.component';
import { TestComponent } from './test/test.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AutocompleteModule } from 'ng2-input-autocomplete';
import { ManageUserGroupComponent } from './manage-user-group/manage-user-group.component';
import { AdminUserProfileComponent } from './admin-user-profile/admin-user-profile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ExternalUserProfileComponent } from './external-user-profile/external-user-profile.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { ManageCountryGroupComponent } from './manage-country-group/manage-country-group.component';
import { MasqueradeComponent } from './masquerade/masquerade.component';



@NgModule({

  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    HttpClientModule, 
    AngularEditorModule, 
    BrowserAnimationsModule,
    ToastrModule.forRoot() ,
    RouterModule.forChild(dashboardRoutes),
   	FormsModule,
  	ReactiveFormsModule,
    CommonModule, 
    NgbModule,
    SharedModule,
    EditorModule,
    ImageCropperModule,
    AutocompleteModule.forRoot()
  ],
  providers: [
    AuthGuard,
    RoleGuard,
	
  ],
  declarations: [
    DisclaimerComponent,
    SectionComponent,
    SearchPanelComponent,
    BoxComponent,   
    SearchPipe,
    FilterBySettings,
    FilterByReviewer,
    FilterByUser,
    highlight,
    
    ListItemComponent,
    DashboardChartComponent,
    LayoutComponent,
    HomeComponent,
    EventCalenderComponent,
    BaseComponent,
    MonthViewCompnent,
    NgbdModalContent,
    NgbdModalBasic,
    ArticleComponent,
    CreateArticleComponent,
    EditorZoom,
    ViewArticleComponent,
    NewsletterListComponent,
    NewsletterViewComponent,
    PrivacyComponent,
    TemplateComponent,

    SettingsComponent,
    ManageArticleTypeComponent,
    ManageTemplateGroupComponent,
    ManageArticleCategoryComponent,


    TemplaterComponent,
    SearchComponent,
    UserManagementComponent,
    TemplateListComponent,
    UserSetPermissionComponent,
    CommentreplyComponent,
    NotificationListComponent,
    TestComponent,
    ManageUserGroupComponent,
    AdminUserProfileComponent,
    UserProfileComponent,
    ExternalUserProfileComponent,
    AnalyticsComponent,
    ManageCountryGroupComponent,
    MasqueradeComponent

  ],
  entryComponents: [NgbdModalContent,NgbdModalBasic,EditorZoom]
})
export class DashboardModule { }
